import React, { FC } from "react";
import { BreadcrumbItemData } from "~/components/modules/SingleLineBreadcrumb";
import {
  convertUrlObjectToString,
  getHostFromProjectId,
} from "~/lib/utils/urlHelper";

interface Props {
  items: BreadcrumbItemData[];
}

const BreadcrumbStructuredData: FC<Props> = ({ items }) => {
  const itemListData = items.map((item, idx) => {
    return {
      "@type": "ListItem",
      item: item.url
        ? convertUrlObjectToString({
            url: { ...item.url, host: getHostFromProjectId() },
          })
        : undefined,
      name: item.text,
      position: idx + 1,
    };
  });

  return (
    <noscript
      dangerouslySetInnerHTML={{
        __html: `
        <script type="application/ld+json">
        {
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": ${JSON.stringify(itemListData)}
        }
        </script>
        `,
      }}
    />
  );
};

export default BreadcrumbStructuredData;
